import { render } from "./RandomCasesSlider.vue?vue&type=template&id=70900cd0&scoped=true"
import script from "./RandomCasesSlider.vue?vue&type=script&lang=js"
export * from "./RandomCasesSlider.vue?vue&type=script&lang=js"

import "./RandomCasesSlider.vue?vue&type=style&index=0&id=70900cd0&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70900cd0"]])

export default __exports__